export default "__VITE_ASSET__e038d573__"